import { Injectable } from '@angular/core';
import { DataService } from '../components/shared/services/data.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SigopServiceService extends DataService {


  private url = this.urlApi + 'v1/turmaSigop/';

    constructor(private http: HttpClient) {
      super();
    }

    getByCpfAndTurma(cpf: string, turma: number) {
      return this.http.get(this.url + 'getByCpfAndTurma/' + cpf + '/' + turma)
        .catch(this.handleError);
    }

    getByIdAndTurma(id: string) {
      return this.http.get(this.url + 'getByIdAndTurma/' + id)
        .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/sigop-service.service.ts